
import { timeRangeOptions, RETURN_REASON_OPTIONS } from "@/utils/options";


const dateTypeOptions = [
    {id: 'returnMarketDate', text: '退货时间(站点时区)'},
    {id: 'returnZeroDate', text: '退货时间(零时区)'},
    {id: 'purchaseDate', text: '订购时间(站点时区)'}
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '退货原因',
    prop: 'reason',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'reason',
        propsData: {
            options: RETURN_REASON_OPTIONS,
            placeholder: '退货原因',
        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'returnMarketDate'
}]
